import * as types from './mutation-types'
import moment from 'moment'
import { storeClient } from '@/service/apiClients'

export default {
  async syncOrderChannel ({ state, rootGetters, commit }, payload = { channel: 'main', params: {} }) { // payload: { filterConfig, channel }
    if (payload.getFilterConfig) {
      commit(types.SET_FILTER_CONFIG, { getFilterConfig: payload.getFilterConfig, channel: payload.channel })
    }
    // TODO: set filterConfig state
    const { data: orderList } = await storeClient.post(`/stores/${rootGetters.storeId}/searchOrder`, (payload.getFilterConfig || state.channels[payload.channel].getFilterConfig)(payload.params || {}))
    commit(types.SET_ORDER_LIST, { orderList, channel: payload.channel, params: payload.params || {} })
  },
  deleteOrder ({ dispatch }, order) {
    dispatch('updateOrder', { order: Object.assign({}, order, { deletedAt: moment().toISOString() }) })
  },
  setItemDone ({ state, dispatch }, { orderId, index, done, channel = 'main' }) {
    const orderIndex = state.channels[channel].orderList.findIndex(o => o.id === orderId)
    if (orderIndex !== -1) {
      const item = Object.assign({}, state.channels[channel].orderList[orderIndex].data.items[index], { done })
      const items = state.channels[channel].orderList[orderIndex].data.items.slice()
      items[index] = item
      const data = Object.assign({}, state.channels[channel].orderList[orderIndex].data, { items })
      dispatch('updateOrder', { order: Object.assign({}, state.channels[channel].orderList[orderIndex], { data }) })
    }
  },
  async setOrderPaid ({ rootState, state, rootGetters, commit }, { order, channel = 'main' }) {
    const index = state.channels[channel].orderList.findIndex(o => o.id === order.id)
    const orderSnapshot = index === -1 ? null : state.channels[channel].orderList[index]
    try {
      commit(types.UPDATE_ORDER_FROM_UI, { order, ring: rootState.settings.newOrderRing })
      await storeClient.put(`/stores/${rootGetters.storeId}/orders/${order.publicId}/pay`, { paymentMethod: 'cash' })
    } catch (e) {
      if (orderSnapshot) {
        commit(types.UPDATE_ORDER_FROM_UI, { order: orderSnapshot, ring: rootState.settings.newOrderRing })
      }
      commit(types.SET_ERROR_MESSAGE, '網路連線失敗，訂單操作無法同步至雲端，請重新整理後再試一次')
      console.error('[OrderModule/Actions/setOrderPaid]: ' + e)
    }
  },
  async updateOrder ({ rootState, state, rootGetters, commit }, { order, channel = 'main' }) {
    const orderSnapshot = Object.assign({}, order)
    try {
      commit(types.UPDATE_ORDER_FROM_UI, { order, ring: rootState.settings.newOrderRing })
      await storeClient.put(`/stores/${rootGetters.storeId}/order`, order)
    } catch (e) {
      if (orderSnapshot) {
        commit(types.UPDATE_ORDER_FROM_UI, { order: orderSnapshot, ring: rootState.settings.newOrderRing })
      }
      commit(types.SET_ERROR_MESSAGE, '網路連線失敗，訂單操作無法同步至雲端，請重新整理後再試一次')
      console.error('[OrderModule/Actions/updateOrder]: ' + e)
    }
  },
  setOrderErrorMessage ({ commit }, message) {
    commit(types.SET_ERROR_MESSAGE, message)
  }
}
